export default "__VITE_ASSET__DZeeeyic__"